
import { Options, Vue } from 'vue-class-component';
import Multiselect from '@vueform/multiselect';
import router from '@/router';
import api from '@/services/Api';
import swal from 'sweetalert2';
import Q from 'q';

@Options({
  props: {
    items: {
      type: [],
      required: true,
    },
    agencyId: {
      type: Number,
      required: true,
    },
  },
  name: 'AgencyUsers',
  components: {
    Multiselect,
  },
  data() {
    return {
      filteredUsers: [],
    };
  },
  computed: {
    showUsers() {
      if (this.ShowDefaultUsers) {
        return this.items;
      }
      return this.users;
    },
  },
})
export default class AgencyUsers extends Vue {
  protected readonly agencyId!: number;
  public showMore = false;
  public users: AgencyUser[] = [];
  public ShowDefaultUsers = true;
  public searchText = '';
  editUser(userId: number) {
    router.push({ name: 'EditAgencyUser', params: { agencyId: this.agencyId, id: userId } });
  }
  async showMoreUsers() {
    await this.getUsersByFilter();
  }
  async getUsersByFilter() {
    this.ShowDefaultUsers = false;
    swal.showLoading();
    const apiResult = await api.SearchAgencyUsers(this.searchText, this.agencyId);
    await Q.delay(400);
    if (apiResult.errorMessage) {
      swal.fire({ icon: 'error', title: 'Oops...', text: apiResult.errorMessage });
      return;
    }
    this.users = apiResult.data?.users || [];
    swal.close();
  }
}
